import React from "react";

import HTML from "../assets/html.png";
import CSS from "../assets/css.png";
import JavaScript from "../assets/javascript.png";
import TypescriptLogo from "../assets/typescript.png";
import VueJs from "../assets/vuejs.png";
import ReactLogo from "../assets/react.png";
import CodeIgniter from "../assets/codeigniter.jpg";
import Symfony from "../assets/symfony.png";
import Angular from "../assets/angular.png";
import Node from "../assets/node.jpg";
import FireBase from '../assets/firebase.png';
import dotnet from '../assets/dot_net.png';
import GitHub from "../assets/github.png";
// import GitLab from "../assets/gitlab.png";
import Tailwind from "../assets/tailwind.png";
import Mongo from "../assets/mongo.png";
import MySql from "../assets/mysql.png"
import PhpLogo from "../assets/php.png";
import Docker from "../assets/docker.png";
import CSharp from "../assets/c-sharp.png";

const Skills = () => {
  return (
    <div name="skills" className="bg-[#0a192f] text-gray-300 w-full min-h-screen">
      {/* Container */}
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-blue-600 text-center">
            Skills
          </p>
          <p className="py-4">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8">
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={HTML} alt="HTML icon" />
            <p className="pt-4 pb-2">HTML</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={CSS} alt="CSS icon" />
            <p className="pt-4 pb-2">CSS</p>
            {/* <p className="pb-1">v 5.12</p> */}
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={JavaScript} alt="Javascript icon" />
            <p className="pt-4 pb-2">Javascript</p>
            {/* <p className="pb-1">v 5.12</p> */}
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={TypescriptLogo} alt="Typescript icon" />
            <p className="pt-4 pb-2">Typescript</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={PhpLogo} alt="Php icon" />
            <p className="pt-4 pb-2">PHP</p>
            {/* <p className="pb-1">v 7.3+</p> */}
          </div>
          <div class="hover:scale-110 duration-500">
            <img class="w-20 mx-auto" src={CSharp} alt="C# icon" />
            <p class="pt-4 pb-2">C#</p>
          </div>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8">
        <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Angular} alt="Angular icon" />
            <p className="pt-4 pb-2">Angular</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={ReactLogo} alt="React icon" />
            <p className="pt-4 pb-2">React</p>
            {/* <p className="pb-1">v 16+</p> */}
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={VueJs} alt="VueJs icon" />
            <p className="pt-4 pb-2">Vue Js</p>
            {/* <p className="pb-1">v 3.2+</p> */}
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Symfony} alt="Symfony icon" />
            <p className="pt-4 pb-2">Symfony</p>
            {/* <p className="pb-1">v 5.4.12+</p> */}
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={dotnet} alt=".NET icon" />
            <p className="pt-4 pb-2">.NET</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={CodeIgniter} alt="Code Igniter icon" />
            <p className="pt-4 pb-2">CodeIgniter</p>
            {/* <p className="pb-1">v 4.2.4</p> */}
          </div>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8">
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={GitHub} alt="Github icon" />
            <p className="pt-4 pb-2">Github</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Docker} alt="Docker icon" />
            <p className="pt-4 pb-2">Docker</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Tailwind} alt="Tailwind icon" />
            <p className="pt-4 pb-2">Tailwind</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={FireBase} alt="Firebase icon" />
            <p className="pt-4 pb-2">Firebase</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Mongo} alt="MongoDB icon" />
            <p className="pt-4 pb-2">MongoDB</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={MySql} alt="MySql icon" />
            <p className="pt-4 pb-2">MySql</p>
          </div>
          <div className="hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={Node} alt="Node js icon" />
            <p className="pt-4 pb-2">NodeJs</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Skills;
